import React from "react";

const FilterIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24px"
      height="24px"
      version="1.1"
      viewBox="0 0 264.58 264.58"
    >
      <rect width="264.58" height="264.58" fill="#fff" />
      <g
        transform="translate(-244.09 -2.2157)"
        fill="none"
        strokeLinecap="round"
        strokeMiterlimit="4"
        strokeWidth="7.9375"
      >
        <path
          d="m359.34 88.205h78.841"
          stroke="#4d4d4d"
          strokeLinejoin="miter"
        />
        <path
          d="m314.58 88.205h17.514"
          stroke="#4d4d4d"
          strokeLinejoin="miter"
        />
        <path
          d="m373.61 180.81h64.57"
          stroke="#4d4d4d"
          strokeLinejoin="miter"
        />
        <path
          d="m314.58 180.81h31.785"
          stroke="#4d4d4d"
          strokeLinejoin="miter"
        />
        <path
          d="m427.86 134.51h10.321"
          stroke="#0573e1"
          strokeLinejoin="miter"
        />
        <path
          d="m314.58 134.51h86.034"
          stroke="#0573e1"
          strokeLinejoin="miter"
        />
        <circle cx="345.72" cy="88.205" r="13.622" stroke="#4d4d4d" />
        <circle cx="414.24" cy="134.51" r="13.622" stroke="#0573e1" />
        <circle cx="359.99" cy="180.81" r="13.622" stroke="#4d4d4d" />
      </g>
    </svg>
  );
};
export default FilterIcon;
